import { render, staticRenderFns } from "./Publicindex.vue?vue&type=template&id=8a193a80&scoped=true&"
import script from "./Publicindex.vue?vue&type=script&lang=js&"
export * from "./Publicindex.vue?vue&type=script&lang=js&"
import style0 from "./Publicindex.vue?vue&type=style&index=0&id=8a193a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a193a80",
  null
  
)

export default component.exports